// extracted by mini-css-extract-plugin
export default {"icon":"SetupDismantleTable_icon__34k8W"};